import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import moment from 'moment'
import es from './locales/es.json'
import en from './locales/en.json'

export type AppLanguage = 'es' | 'en'

/** Request header zumma-service reads to localize generated content, such as downloaded files. */
export const LANGUAGE_HEADER = 'X-Zumma-Language'

/**
 * Maps an i18next language tag ('en-US', 'es-MX', undefined...) to a supported app language.
 * @param lng - Language tag reported by i18next
 * @returns 'en' for any English tag, 'es' otherwise
 */
export const normalizeLanguage = (lng?: string | null): AppLanguage => (lng?.startsWith('en') ? 'en' : 'es')

/**
 * Current app language, normalized to a supported code.
 * @returns The language the user is viewing the dashboard in
 */
export const getCurrentLanguage = (): AppLanguage => normalizeLanguage(i18n.resolvedLanguage ?? i18n.language)

i18n.on('languageChanged', (lng: string) => {
  moment.locale(normalizeLanguage(lng))
})

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en }
    },
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage']
    }
  })

export default i18n
